import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex bg-plum-200 text-plum-600 border border-transparent justify-center items-center whitespace-nowrap shrink-0 overflow-hidden py-1 rounded-sm font-medium leading-4',
  {
    variants: {
      size: {
        sm: 'h-5 px-2 text-xs',
        md: 'h-6 px-4 text-sm',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);
